import { webpackRequire2obj } from '@/utils'
let contents = webpackRequire2obj(require.context('./', true, /\.\/(\w+\/)+\w+\.js/), [])
export default contents


// WEBPACK FOOTER //
// ./src/apis/index.js